import { render, staticRenderFns } from "./EditMemberAscend.vue?vue&type=template&id=55d9d256&scoped=true"
import script from "./EditMemberAscend.vue?vue&type=script&lang=js"
export * from "./EditMemberAscend.vue?vue&type=script&lang=js"
import style0 from "./EditMemberAscend.vue?vue&type=style&index=0&id=55d9d256&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d9d256",
  null
  
)

export default component.exports